// import { Ollama } from "ollama";

// const ollama = new Ollama();
// await ollama.setModel("llama3.1");

const recommendTags = async (tree, url) => {
    // const response = await ollama.chat({
    //     model: 'llama3.1',
    //     messages: [{ role: 'user', content: 'Why is the sky blue?' }],
    // })
    // return response.message.content
}

const IAHelper = {
    recommendTags,
}
export default IAHelper;
